import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { sellerBrandSuggestionApi, getOrderItemReportApi, exportOrderItemReportApi } from "../../../../services/report";

import { CancelToken } from "../../../../utils/api";
import axios from "axios";

let cancelSource;

export const getOrderItemReport = createAsyncThunk('report/getOrderItemReport', async (data, { dispatch }) => {
    // Cancel any ongoing request
    if (cancelSource) {
        cancelSource.cancel("Cancelled due to new request.");
    }

    // Create new cancel token
    cancelSource = CancelToken.source();
    
    const response = await getOrderItemReportApi(data, cancelSource.token);
    dispatch(setTableRowCount(response.response.count));
    dispatch(setItems(response.response.data));
    // dispatch(setTotalSummary(response.response.total_summary));
    return response.response.data;
});

export const getBrands = createAsyncThunk('product/brand-auto-suggestion', async (data, { dispatch, }) => {
    const response = await sellerBrandSuggestionApi(data);
    return response.response;
});

export const exportOrderItemReport = createAsyncThunk('report/exportOrderItemReport', async (data, { dispatch, }) => {
    const response = await exportOrderItemReportApi(data);
    return response.response;
});

const orderItemReportAdapter = createEntityAdapter({});

export const { selectAll: selectOrderItemReport, selectById: selectOrderItemReportById } = orderItemReportAdapter.getSelectors(
    state => state.report
);

const orderItemReportSlice = createSlice({
    name: 'orderItemReport',
    initialState: orderItemReportAdapter.getInitialState({
        id: null,
        tableRow: 0,
        items: [],
        // totalSummary: {
        //     total_beginning_quantity: 0,
        //     total_added_quantity: 0,
        //     total_end_quantity: 0,
        //     total_ordered_quantity: 0,
        //     total_restocked_quantity: 0,
        //     total_processed_quantity: 0,
        //     total_handling_actions: 0,
        //     total_handling_changes_per_item: 0,
        // },
    }),
    reducers: {
        setTableRowCount: (state, action) => {
            state.tableRow = action.payload;
        },
        // setTotalSummary: (state, action) => {
        //     state.totalSummary = action.payload;
        // },
        setItems: (state, action) => {
            state.items = action.payload;
        },
    },
    extraReducers: {
        // [getOrderItemReportData.fulfilled]: orderItemReportAdapter.setAll
    }
});

export const {
    setTableRowCount,
    // setTotalSummary,
    setItems
} = orderItemReportSlice.actions;

export default orderItemReportSlice.reducer;